export default __webpack_public_path__ + "static/media/trus2.292e566b.png";